import { type Room } from 'livekit-client'

import { findNearestText } from 'modules/ai_voice/lib/observers/find-text'
import { performRpc } from 'modules/ai_voice/lib/rpc'

let handleChange: ((event: Event) => void) | null = null

export function registerSelectObserver(room: Room): void {
  function notifyOptionSelected(option: string, field: string) {
    performRpc(room, 'optionSelected', { option, field }).catch(() => {})
  }

  handleChange = (event) => {
    if (!event.isTrusted || !(event.target instanceof HTMLSelectElement)) {
      return
    }

    const selectedOption = event.target.selectedOptions.item(0)?.textContent?.trim()

    if (!selectedOption) {
      return
    }

    const field = findNearestText(event.target)
    void notifyOptionSelected(selectedOption, field)
  }

  document.addEventListener('change', handleChange, true)
}

export function unregisterSelectObserver(): void {
  if (handleChange) {
    document.removeEventListener('change', handleChange, true)
    handleChange = null
  }
}
